/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { TypeRampV2, sizes, Button } from '@smartsheet/lodestar-core';
import { AddIcon } from '@smartsheet/lodestar-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setIsUpsertScheduleVisible } from '../../../../../../services/ducks/schedulesDuck';

const containerStyle = css`
  display: flex;
  justify-content: center;
  margin-top: ${sizes.xxLarge * 2 - 16}px;
  flex-direction: column;
  align-items: center;
`;

const titleStyle = css`
  text-align: center;
  margin: 0;
  margin-bottom: ${sizes.large}px;
`;

export const NoWorkflowSchedules = () => {
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();

  return (
    <div css={containerStyle}>
      <TypeRampV2
        system="lodestar"
        variant="headerLarge"
        renderAs="h5"
        css={titleStyle}
      >
        {translate('designer:triggerPanel:schedules:noSchedules')}
      </TypeRampV2>
      <Button
        appearance="primary"
        size="large"
        onClick={() => {
          dispatch(setIsUpsertScheduleVisible(true));
        }}
        iconBefore={<AddIcon />}
      >
        {translate('designer:triggerPanel:schedules:addNewSchedule')}
      </Button>
    </div>
  );
};
